import RedeemHistoryRow from './RedeemHistoryRow'
import styles from './style.css'

class RedeemHistory extends React.Component {
  static maximumRedemptionsToShow = 5

  render () {
    let {customerDetail} = this.props

    return (
      <div className='customer-info-box'>
        <div className='header2'>
          Redeem History
        </div>
        {customerDetail && customerDetail.redemptions &&
          customerDetail.redemptions.content && customerDetail.redemptions.content.length
            ? <table style={{marginBottom: '0px'}} className='table mk-table-fixed mk-table-clickable moka-table-details'>
              <thead>
                <tr>
                  <th className='col-md-3'>
                  Date
                </th>
                  <th className='col-md-7'>
                  Reward
                </th>
                  <th className='col-md-2 text-right'>
                  Point
                </th>
                </tr>
              </thead>
              <tbody>
                {this._getRedemptionRowsView(customerDetail.redemptions)}
                {customerDetail.redemptions.total_elements > RedeemHistory.maximumRedemptionsToShow &&
                <tr>
                  <td onClick={this._onClickSeeMore} className={`${styles['see-more']} col-md-2`}>+ See More</td>
                </tr>
              }
              </tbody>
            </table>
          : <div className={`${styles['no-redeem-histories']}`}> <i>No redeem history</i> </div>
        }
      </div>
    )
  }

  _getRedemptionRowsView = (redemptions) => {
    let redemptionList = []
    for (let i = 0; (i < redemptions.content.length && i < RedeemHistory.maximumRedemptionsToShow); i++) {
      let redemption = redemptions.content[i]
      redemptionList.push(
        <RedeemHistoryRow redemption={redemption} key={redemption.redeemId} onClickRow={this._onClickRow} />
      )
    }

    return redemptionList
  }

  _onClickSeeMore = () => {
    this.props.seeMore(this.props.customerDetail.id)
  }

  _onClickRow = (data) => {
    this.props.onClickHistory(data)
  }
}

RedeemHistory.propTypes = {
  customerDetail: React.PropTypes.object,
  seeMore: React.PropTypes.func,
  onClickHistory: React.PropTypes.func
}

export default RedeemHistory



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/RedeemHistory.js